export default __webpack_public_path__ + "static/media/title_th_sp.2a53fda9.png";